import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getAccountType = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/account-type/list` });

  return data?.data;
};

export default getAccountType;
